import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function fetchExternalImage(data, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/upload`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return response;
}

export function useExternalImage(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => fetchExternalImage(data, authHeaders),
        ...options
    });
}